module.exports = __webpack_public_path__ + "img/tag.a6351445.svg";